<template>
  <draggable :list="value" class="col-12" @change="changeComponentsOrder">
    <b-card no-body v-for="component in value" :key="'component-' + component.id">
      <b-card-header header-bg-variant="teal">
        <font-awesome-icon icon="arrows-alt" class="pointer mr-3 text-white"></font-awesome-icon>
        {{ component.ordinal }} - {{ component.component_type.name.toUpperCase() }}
        <font-awesome-icon icon="times" class="pointer float-right text-danger" @click="deleteComponent(component)"></font-awesome-icon>
      </b-card-header>
      <b-card-body class="p-3">
        <course-builder-header v-model="component.data" v-if="component.component_type.id === 1"></course-builder-header>

        <template v-else-if="component.component_type.id === 3">
          <course-builder-text-block v-model="component.data"></course-builder-text-block>
          <div class="mt-3" v-for="audio in component.audio" :key="'audio-' + audio.id">
            <h6>Generated Audio</h6>
            <audio-player :file="audio.url"></audio-player>
          </div>
        </template>

        <course-builder-image v-model="component.images" :component_id="component.id" v-else-if="component.component_type.id === 4"></course-builder-image>
        <course-builder-audio v-model="component.audio" :component_id="component.id" v-else-if="component.component_type.id === 6"></course-builder-audio>
        <course-builder-file v-model="component.documents" :component_id="component.id" v-else-if="component.component_type.id === 8"></course-builder-file>
        <course-builder-learning-activity v-model="component.data" v-else-if="component.component_type.id === 9"></course-builder-learning-activity>
        <course-builder-video v-model="component.data" v-else-if="component.component_type.id === 7"></course-builder-video>
        <div v-else-if="component.component_type.id === 2">
          <hr/>
        </div>
        <span v-else>{{ component }}</span>
      </b-card-body>
    </b-card>
  </draggable>
</template>

<script>
import CourseBuilderHeader from './CourseBuilderHeader';
import CourseBuilderTextBlock from './CourseBuilderTextBlock';
import CourseBuilderImage from './CourseBuilderImage';
import CourseBuilderAudio from './CourseBuilderAudio';
import CourseBuilderFile from './CourseBuilderFile';
import findIndex from 'lodash-es/findIndex';
import CourseBuilderLearningActivity from './CourseBuilderLearningActivity';
import CourseBuilderVideo from './CourseBuilderVideo';
import AudioPlayer from '../AudioPlayer';

export default {
  name: 'CourseBuilder',
  components: {AudioPlayer, CourseBuilderVideo, CourseBuilderLearningActivity, CourseBuilderFile, CourseBuilderAudio, CourseBuilderImage, CourseBuilderTextBlock, CourseBuilderHeader},
  data () {
    return {};
  },
  methods: {
    deleteComponent (component) {
      let index = findIndex(this.value, {id: component.id});
      let components = [...this.value];
      components.splice(index, 1);
      components = components.map((field, x) => {
        field.ordinal = x + 1;
        return field;
      });

      this.axios.delete('/components/' + component.id);

      this.$emit('input', components);
    },
    changeComponentsOrder () {
      let components = [...this.value];
      components = components.map((component, index) => {
        component.ordinal = index + 1;

        return component;
      });

      this.$emit('input', components);

      return true;
    }
  },
  mounted () {
    this.$store.dispatch('LOAD_LEARNING_ACTIVITIES', this);
    this.$store.dispatch('LOAD_VIDEOS', this);
  },
  props: {
    value: {
      type: Array
    }
  }
};
</script>
